<template>
    <AccountGuestLayout>
        <ResetPasswordForm @success="handleSignIn"/>
    </AccountGuestLayout>
</template>
<script setup>
import AccountGuestLayout from "../../layouts/AccountGuestLayout.vue";
import ResetPasswordForm from "../../components/Account/ResetPasswordForm.vue";
import {useRoute, useRouter} from "vue-router";

const router = useRouter();
const route = useRoute();

const handleSignIn = () => {
    if (route.query.redirect) {
        router.push(route.query.redirect);
    } else {
        router.push({ name: 'login' });
    }
}
</script>
